module.exports = __webpack_public_path__ + "static/media/icon-truck.2faacf02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-summary/icon-truck.svg
// module id = 483
// module chunks = 0 1 2